<template>
  <div>
    <ioc-form :option="detailOption" v-model="alarmDetail">
      <template slot-scope="scope" slot="alarmName">
        <span :title="scope.value">{{ scope.value }}</span>
      </template>
      <template slot-scope="scope" slot="alarmTypeLabel">
        <span>{{ scope.value }}</span>
      </template>
      <template slot-scope="scope" slot="reportPersonName">
        <span>{{ scope.value }}</span>
      </template>
      <!-- 有毒有害气体 -->
      <template slot-scope="scope" slot="deviceName">
        <span>{{ scope.value }}</span>
      </template>
      <template slot-scope="scope" slot="parentDeviceName">
        <span>{{ scope.value }}</span>
      </template>
      <template slot-scope="scope" slot="concentration">
        <span>{{ scope.value }}</span>
      </template>
      <!--一键求救-->
      <template slot-scope="scope" slot="alarmSubType">
        <span>{{ scope.value | dic("SENU103") }}</span>
      </template>
      <template slot-scope="scope" slot="deviceName">
        <span>{{ scope.value }}</span>
      </template>
      <template slot-scope="scope" slot="groupName">
        <span>{{ scope.value }}</span>
      </template>
      <template slot="alarmLevel">
        <span>{{ alarmLevel() }}</span>
      </template>
      <!-- 超速告警 -->
      <template
        slot-scope="scope"
        v-if="alarmDetail.alarmType === '80101'"
        slot="overSpeed"
      >
        <div>
          <span class="mr5">{{ scope.value }}</span>
          <span v-if="scope.value">km/h</span>
        </div>
      </template>
      <template
        slot-scope="scope"
        v-if="alarmDetail.alarmType === '80101'"
        slot="floatSpeed"
      >
        <div>
          <span class="mr5">{{ scope.value }}</span>
          <span v-if="scope.value">km/h</span>
        </div>
      </template>
      <template
        slot-scope="scope"
        v-if="alarmDetail.alarmType === '80101'"
        slot="speed"
      >
        <div>
          <span class="mr5">{{ scope.value }}</span>
          <span v-if="scope.value">km/h</span>
        </div>
      </template>
      <template
        slot-scope="scope"
        v-if="alarmDetail.alarmType === '80101'"
        slot="plateNo"
      >
        <span>{{ scope.value }}</span>
      </template>
      <template
        slot-scope="scope"
        v-if="alarmDetail.alarmType === '80101'"
        slot="personName"
      >
        <span>{{ scope.value }}</span>
      </template>
      <template
        slot-scope="scope"
        v-if="alarmDetail.alarmType === '80101'"
        slot="personPhone"
      >
        <span>{{ scope.value }}</span>
      </template>
      <!-- 超速告警结束 -->
      <template slot-scope="scope" slot="deviceWorkGroupName">
        <span>{{ scope.value }}</span>
      </template>
      <template slot="alarmTime">
        <span>{{ alarmTime() }}</span>
      </template>
      <template slot-scope="scope" slot="ip">
        <span>{{ scope.value || $t("realTimeAlarm.label.noDatas") }}</span>
      </template>
      <template slot-scope="scope" slot="videoUrl">
        <div>
          <div v-if="scope.value">
            <div class="file-list">
              <div
                class="file-item"
                v-for="(item, index) in scope.value.split(',')"
                :key="index"
              >
                <video
                  style="object-fit: fill"
                  class="file-comp"
                  :src="$utils.Bus.imgPath(item)"
                ></video>
                <div
                  style="cursor: pointer"
                  class="play-icon iconfont-lunan icon-lunan-qidong"
                  @click="handleShowVideos(item)"
                ></div>
              </div>
            </div>
          </div>
          <div v-else>
            {{ $t("realTimeAlarm.label.noDatas") }}
          </div>
        </div>
      </template>
      <template slot="realTimeVideo">
        <el-button type="text" @click="viewVideo('live')">
          {{ $t("realTimeAlarm.label.watch") }}
        </el-button>
      </template>
      <template slot="historyVideo">
        <el-button type="text" @click="viewVideo('back')">
          {{ $t("realTimeAlarm.label.watch") }}
        </el-button>
      </template>
      <template slot-scope="scope" slot="desc">
        <div class="word-break-all">
          {{ scope.value || $t("realTimeAlarm.label.noDatas") }}
        </div>
      </template>
      <template slot-scope="scope" slot="plateNo">
        <span>{{ scope.value }}</span>
      </template>
      <template slot-scope="scope" slot="personnelType">
        <span>{{
          scope.value == 1 ? "员工车辆" : scope.value == 2 ? "外来人员车辆" : ""
        }}</span>
      </template>
      <template slot-scope="scope" slot="personName">
        <span>{{ scope.value }}</span>
      </template>
      <template slot-scope="scope" slot="personPhone">
        <span>{{ scope.value }}</span>
      </template>
      <template slot-scope="scope" slot="checkInTime">
        <span>{{ scope.value }}</span>
      </template>
      <template slot-scope="scope" slot="overSpeed">
        <span>{{ scope.value }}小时</span>
      </template>
      <template slot-scope="scope" slot="groupName">
        <span>{{ scope.value }}</span>
      </template>
      <template slot-scope="scope" slot="alarmStateLabel">
        <span>{{ scope.value }}</span>
      </template>
    </ioc-form>

    <!-- 手动上传视频 -->
    <div>
      <el-dialog
        :before-close="handleCloseVideo"
        :visible.sync="dialogShowVideo"
        append-to-body
        title="上传视频"
        width="600px"
      >
        <div style="width: 100%; height: 380px">
          <video
            autoplay
            muted
            style="width: 100%; height: 100%; object-fit: fill"
            controls="controls"
            :src="$utils.Bus.downFile(dialogShowVideoSrc)"
          ></video>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { api } from "../api";
import column from "../options/alarmDetail";
import { Dic, Dates, Bus } from "$utils";
export default {
  props: {
    detail: {
      type: Object,
      default: () => {
        return null;
      },
    },
    emergencyCardList: {
      type: Array,
      default: () => {
        return null;
      },
    },
    alarmType: {
      type: String,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      detailOption: {
        labelWidth: 100,
        menuBtn: false,
        gutter: 14,
        column: [],
      },
      alarmDetail: this.detail,
      linkageDeviceList: [],
      deviceArr: [],
      videoDeviceArr: [],
      dialogShowVideoSrc: "",
      dialogShowVideo: false,
      // alarmType: "",
    };
  },
  mounted() {},
  watch: {
    detail: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.alarmDetail = newVal;
          this.initDetail();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    initDetail() {
      // 上传视频 人脸黑名单，人脸白名单，车辆黑名单不展示
      let videoHide =
        this.detail.alarmType == "50101" ||
        this.detail.alarmType == "50102" ||
        this.detail.alarmType == "50103" ||
        this.detail.alarmType == "50104" ||
        this.detail.alarmType == "50105" ||
        this.detail.alarmType == "80101";
      // 上报人员不存在则不显示
      let nameHide = !this.detail.reportPersonName;
      // this.detailOption.column = column.columnFire()
      if (this.detail.subSystem === "9") {
        // 手工告警 没有视频和录像
        this.detailOption.column = column.columnHandle();
      } else if (this.detail.subSystem === "12") {
        // 一键求救
        this.detailOption.column = column.columnHelp();
      } else if (this.detail.subSystem === "14") {
        // 有毒有害气体
        this.detailOption.column = column.columnGas();
      } else if (this.detail.alarmType === "80101") {
        this.detailOption.column = column.columnSpeed();
      } else if (this.detail.alarmType === "80103") {
        this.detailOption.column = column.columnOverTime();
      } else if (videoHide && nameHide) {
        this.detailOption.column = column.columnNone();
      } else if (videoHide && !nameHide) {
        this.detailOption.column = column.columnName();
      } else if (!videoHide && nameHide) {
        this.detailOption.column = column.columnVideo();
      } else {
        this.detailOption.column = column.columnAll();
      }
      console.log(
        this.detailOption.column,
        this.detail,
        this.alarmDetail,
        "===this.detailOption.column"
      );
      
    },
    alarmLevel() {
      return Dic.findByValue("SENU017", this.detail.alarmLevel);
    },
    alarmName() {
      let item = this.detail;
      if (item) {
        if (item.subSystem === "10") {
          this.$t("realTimeAlarm.title.patrol") + item.deviceName;
        } else {
          return (
            "[" +
            item.subSystemLabel +
            "]" +
            item.alarmTypeLabel +
            (item.deviceName ? "_" + item.deviceName : "")
          );
        }
      } else {
        return "告警名称";
      }
    },
    alarmTime() {
      let item = this.detail;
      if (item) {
        return Dates.format(item.alarmTime, "yyyy-MM-dd HH:mm:ss");
      }
    },
    // 获取联动设备
    getFastLinkDev(type) {
      const paramsLink = {
        alarmType: this.detail.alarmType,
        deviceCode: this.detail.alarmDevId,
        subSystem: this.detail.subSystem,
      };
      this.deviceArr = [];
      this.videoDeviceArr = [];
      let currentDevice = {
        deviceName: this.detail.deviceName,
        thirdDeviceId: this.detail.thirdAlarmDevId,
      };
      this.deviceArr.push(currentDevice);
      this.videoDeviceArr.push(currentDevice);
      if (this.deviceArr.length == 1 || this.videoDeviceArr.length == 1) {
        this.$emit("playVideo", type);
      } else {
        this.$emit(
          "showDeviceList",
          type,
          type == "live" ? this.deviceArr : this.videoDeviceArr
        );
      }
    },
    // 查看录像
    viewVideo(type) {
      console.log(this.detail);
      if (!this.detail.thirdAlarmDevId) {
        this.$message.error(this.$t("realTimeAlarm.message.noDevice"));
        return;
      }
      if (type == "back" && !this.detail.startTime && !this.detail.endTime) {
        this.$message.error(this.$t("realTimeAlarm.message.noPlan"));
        return;
      }
      this.getFastLinkDev(type);
    },
    // 播放手动mp4
    handleShowVideos(src) {
      this.dialogShowVideoSrc = src;
      this.dialogShowVideo = true;
    },
    // 关闭播放mp4
    handleCloseVideo() {
      this.dialogShowVideo = false;
      this.dialogShowVideoSrc = "";
    },
  },
};
</script>
<style lang="scss" scoped>
.file-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.file-item {
  margin-right: 5px;
  background-color: rgba(24, 31, 46, 0.65);
  position: relative;
  .play-icon {
    position: absolute;
    top: 1px;
    left: 30px;
    font-size: 22px;
    &:hover {
      font-size: 25px;
    }
  }
}

.file-item,
.file-comp {
  height: 88px;
  width: 88px;
  line-height: 88px;

  &:nth-child(3) {
    margin-right: 0;
  }
}
</style>